module.exports = __webpack_public_path__ + "app/components/busy-indicator-37EbW9Dm.html";